// the tool that is used to generate typescript types from beaufort-api (oazapfts)
// doesn't generate enums, but simple union types of strings
// since typescript does not allow creating an array of values from a union type
// this internal array of values is defined here
import api from "../api";

export const RiskTypes: api.RiskLevel[] = ["LOW", "MEDIUM", "HIGH"];
export const ReversedRiskTypes: api.RiskLevel[] = [...RiskTypes].reverse();
